import { formatAmount } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import parseAmount from '../../common/parseAmount';
import createClassNamesFromStyles from '../../resources/createClassNamesFromStyles';
import style from '../TravelMoney.module.less';

const createClassNames = createClassNamesFromStyles(style);

const formatAmountIfSet = (amount, currency, locale) =>
  amount ? formatAmount(amount, currency, locale) : '';

const AmountInput = ({ amount, onAmountChange: onAmountChangeProperty, currencyCode }) => {
  const { locale } = useIntl();
  const [formattedAmount, updateFormattedAmount] = useState(
    formatAmountIfSet(amount, currencyCode, locale),
  );
  const [isFocused, updateIsFocused] = useState(false);

  const formatInput = () => {
    const parsed = parseAmount(formattedAmount, currencyCode, locale);
    if (!Number.isNaN(parsed)) {
      updateFormattedAmount(formatAmountIfSet(parsed, currencyCode, locale));
    }
  };

  useEffect(() => {
    if (!isFocused) {
      const formatted = formatAmountIfSet(amount, currencyCode, locale);
      updateFormattedAmount(formatted);
    }
  }, [amount, currencyCode, locale]);

  const onAmountChange = (event) => {
    const {
      target: { value },
    } = event;
    updateFormattedAmount(value);
    const parsed = parseAmount(value, currencyCode, locale);
    if (!Number.isNaN(parsed)) {
      onAmountChangeProperty(parsed);
    }
  };

  const onAmountFocus = () => {
    updateIsFocused(true);
  };

  const onAmountBlur = () => {
    updateIsFocused(false);
    formatInput();
  };

  return (
    <label htmlFor="amountInput" className={createClassNames(['label', 'OptionsForm__label'])}>
      <span className={style['sr-only']}>
        <FormattedMessage id="amount" />
      </span>
      <input
        id="amountInput"
        className={createClassNames(['form-control', 'OptionsForm__amount'])}
        value={formattedAmount}
        name="amount"
        onChange={onAmountChange}
        onFocus={onAmountFocus}
        onBlur={onAmountBlur}
      />
    </label>
  );
};

AmountInput.propTypes = {
  amount: PropTypes.number.isRequired,
  onAmountChange: PropTypes.func.isRequired,
  currencyCode: PropTypes.string.isRequired,
};

export default AmountInput;
